module.exports = __webpack_public_path__ + "img/tram.bdb88480.svg";